type Units = 0.5 | 1 | 1.5 | 2 | 2.5 | 3 | 4 | 5 | 6 | 8;
type UnitOutput = 4 | 8 | 12 | 16 | 20 | 24 | 32 | 40 | 48 | 64;

export function unit(amount: Units): UnitOutput {
    return (amount * 8) as UnitOutput;
}

export const u = unit;
